import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/api";
import { Trash2, Plus } from "lucide-react";

export default function SettingsLocations() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ name: "", city: "", province: "" });
  const [busy, setBusy] = useState(false);

  const load = () => { setLoading(true); api.get("/locations").then((r) => setItems(r.data || [])).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return;
    setBusy(true);
    try { await api.post("/locations", form); toast.success("Location added."); setForm({ name: "", city: "", province: "" }); load(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  const del = async (loc) => {
    if (!window.confirm(`Delete location "${loc.name}"?`)) return;
    try { await api.delete(`/locations/${loc.id}`); toast.success("Deleted."); load(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
  };

  return (
    <DashboardLayout>
      <h1 className="text-2xl sm:text-3xl font-bold" data-testid="locations-heading">Locations</h1>
      <p className="mt-1 text-sm text-[#3B424B]">Tag each upload with a location and see reorder / pricing per store.</p>

      <form onSubmit={add} className="mt-6 tm-card p-5 bg-white grid sm:grid-cols-4 gap-3 items-end max-w-3xl">
        <div><label className="tm-label">Name *</label><input required className="tm-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="locations-name" /></div>
        <div><label className="tm-label">City</label><input className="tm-input" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} data-testid="locations-city" /></div>
        <div><label className="tm-label">Province</label><input className="tm-input" value={form.province} onChange={(e) => setForm({ ...form, province: e.target.value })} data-testid="locations-province" /></div>
        <button className="tm-btn-primary" disabled={busy} data-testid="locations-add"><Plus size={14} /> Add location</button>
      </form>

      <div className="mt-6 tm-card bg-white overflow-hidden max-w-3xl">
        {loading ? <div className="p-6 text-sm text-[#3B424B]">Loading…</div> : items.length === 0 ? (
          <div className="p-6 text-sm text-[#3B424B]" data-testid="locations-empty">No locations yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-[var(--tm-off)] text-left text-xs uppercase tracking-wider text-[#3B424B]"><tr><th className="p-3">Name</th><th className="p-3">City</th><th className="p-3">Province</th><th className="p-3 text-right">Actions</th></tr></thead>
            <tbody>
              {items.map((l) => (
                <tr key={l.id} className="border-t border-[var(--tm-border)]" data-testid={`location-row-${l.id}`}>
                  <td className="p-3 font-semibold">{l.name}</td>
                  <td className="p-3">{l.city || "—"}</td>
                  <td className="p-3">{l.province || "—"}</td>
                  <td className="p-3 text-right">
                    <button className="tm-btn-outline h-8 px-2 text-xs" onClick={() => del(l)} disabled={items.length <= 1} data-testid={`location-delete-${l.id}`}><Trash2 size={13} /> Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </DashboardLayout>
  );
}
